import { Navigate, Route, Routes, resolvePath, useLocation } from 'react-router-dom';

import RewardsMain from './main';
import RewardPage from './reward';

export default function RewardsPage() {
  const location = useLocation();

  return (
    <Routes>
      <Route element={<RewardsMain />} path="" />
      <Route element={<RewardPage />} path=":reward_id/*" />
      <Route element={<Navigate to={resolvePath('..', location.pathname)} />} path="*" />
    </Routes>
  );
}
